// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"Permissions_rowContainer__1imy2","singleRow":"Permissions_singleRow__1Da4L","permissionsModalHeader":"Permissions_permissionsModalHeader__1ZTBt"};